import api from "./axios";
import type { City } from "../types/city";
import { mapCitiesResponse } from "../types/city";

export const getCitiesApi = async (): Promise<City[]> => {
  try {
    const response = await api.get<any>("/api/v1/cities");
    return mapCitiesResponse(response.data);
  } catch (error) {
    console.error("Error fetching cities:", error);
    throw error;
  }
};

interface CreateCityData {
  name: string;
}

export const createCityApi = async (data: CreateCityData) => {
  try {
    const response = await api.post("/api/v1/cities", data);
    return response.data;
  } catch (error) {
    console.error("Error creating city:", error);
    throw error;
  }
};

interface UpdateCityData {
  name: string;
}

export const updateCityApi = async (cityId: string, data: UpdateCityData) => {
  try {
    const response = await api.put(`/api/v1/cities/${cityId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating city:", error);
    throw error;
  }
};
